export const certificateHtml = (user) => `<html>

<head>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
    <link href="https://fonts.googleapis.com/css2?family=Raleway:wght@400;600;700&display=swap" rel="stylesheet">
    <style>
        @page {
            margin-top: 40px;
            margin-bottom: 40px;
        }
        body {
            font-family: 'Raleway', sans-serif;
            color: #333;
            line-height: 1.6;
        }
        .certificate-download {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px;
            background-color: #f8fafc; /* Keep a light background for consistency */
        }
        .certificate {
            background-color: #ffffff;
            border: 1px solid #e0e7ef;
            box-shadow: 0 5px 15px rgba(0,0,0,0.05); /* Lighter shadow */
            width: 210mm; /* A4 width */
            padding: 30px; /* Adjusted padding */
            box-sizing: border-box;
            position: relative;
            overflow: hidden;
            font-family: Raleway; /* Fallback font */
        }

        .section-1 {
            text-align: center;
            margin-bottom: 20px;
        }

        .section-1 img#logo {
            max-width: 180px; /* Adjusted logo size for more compactness */
            height: auto;
            margin-bottom: 10px; /* Reduced margin */
        }

        .section-1 .certificate-title { /* Added class for consistent styling */
            font-size: 32pt; /* Slightly reduced font size */
            color: #333; /* Default text color */
            font-weight: 700;
            letter-spacing: 2px;
            text-transform: uppercase;
        }

        .certificate-body {
            font-size: 14pt; /* Adjusted body font size */
            text-align: center;
            line-height: 1.6; /* Reduced line height */
            margin: 15px auto; /* Adjusted vertical margin */
            max-width: 90%; /* Increased width slightly */
        }

        .certificate-body p {
            margin-bottom: 8px; /* Reduced margin */
            color: #444;
        }

        .certificate-body b {
            color: #967bb6;
            font-weight: 700;
        }

        /* Styles for dynamic headings like "Sharmila is the founder of" */
        .dynamic-heading {
            font-size: 13pt;
            font-weight: 600;
            color: #333;
            margin-top: 20px; /* Spacing above the heading */
            margin-bottom: 8px; /* Spacing below the heading */
            text-align: left; /* Ensure left alignment */
            padding-left: 20px; /* Indent the heading slightly */
        }

        /* Styles for dynamic list items */
        .dynamic-list-item {
            font-size: 11pt;
            color: #555;
            margin-bottom: 3px; /* Space between list items */
            list-style: none; /* Remove default bullet points */
            text-align: left; /* Ensure left alignment */
            padding-left: 30px; /* Indent the list item content */
            position: relative;
        }

        /* Custom bullet point for dynamic list items */
        .dynamic-list-item::before {
            content: "•"; /* Unicode character for a bullet point */
            color: #555; /* Color of the bullet */
            position: absolute;
            left: 20px; /* Position the bullet */
            top: 0;
        }

        ul {
            padding: 0;
            margin: 0;
            list-style: none;
        }

        .badge-section {
            text-align: center;
            margin-top: 20px; /* Reduced margin */
            margin-bottom: 20px; /* Reduced margin */
        }

        .badge-heading { /* New class for badge heading */
            font-size: 13pt;
            font-weight: 600;
            color: #333;
            margin-bottom: 15px; /* Reduced margin */
        }

        .badge-images {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 10px; /* Reduced space between badges */
            margin-top: 15px; /* Reduced margin */
        }

        .badge-image { /* New class for individual badge images */
            max-width: 120px; /* Consistent badge image size */
            height: auto;
            margin: 0; /* Remove default image margins */
            padding: 8px; /* Reduced internal padding */
        }

        .signatures {
            display: flex;
            justify-content: space-around; /* Changed to center for overall centering */
            align-items: flex-end;
            margin-top: 30px; /* Increased margin-top for more space from above content */
            gap: 60px; /* Increased gap between signature blocks */
            /* Removed height:150px; to allow content to dictate height */
            padding-bottom: 30px
        }

        .signatures > div {
            text-align: center;
            /* Removed flex: 1; as justify-content: center will handle spacing */
            padding: 0; /* Removed horizontal padding as gap will handle spacing */
        }

        .signatures img {
            max-width: 80px; /* Adjusted signature image size */
            height: auto;
            margin-bottom: 3px; /* Reduced margin */
            display: block; /* Make image a block element */
            margin-left: auto; /* Center the image */
            margin-right: auto; /* Center the image */
        }

        .signatures p {
            font-size: 9pt;
            line-height: 1.3;
            color: #555;
            text-align: center; /* Ensure text is centered */
        }

        .signatures b {
            color: #333;
            font-weight: 600;
        }

        .ledger {
            margin-top: 40px;
        }

        table {
            border-collapse: collapse;
            width: 100%;
            table-layout: fixed; /* Ensures column widths are respected */
            page-break-inside: avoid; /* Prevents breaking within the table */
            border: 1px solid #e0e7ef; /* Outer border */
            box-shadow: 0 2px 8px rgba(0,0,0,0.03); /* Subtle table shadow */
        }

        thead {
            display: table-header-group; /* This makes the header repeat on each page in PDF */
        }

        th {
            background-color: #967bb6;
            color: white;
            padding: 10px 12px; /* Adjusted padding */
            text-align: left;
            font-weight: 600;
            text-transform: uppercase;
            font-size: 10.5pt; /* Adjusted font size */
        }

        tr:nth-child(even) {
            background-color: #f9f9f9; /* Lighter shade */
        }

        tr:nth-child(odd) {
            background-color: #ffffff;
        }

        td {
            padding: 10px 12px; /* Adjusted padding */
            text-align: left;
            word-wrap: break-word;
            border-bottom: 1px solid #eee; /* Light border between rows */
            font-size: 10pt;
            color: #555;
            vertical-align: top;
        }

        td:nth-child(1) {
            width: 55%; /* Adjusted width for Program Name */
        }

        td:nth-child(2) {
            width: 35%; /* Adjusted width for Event Name */
        }

        td:nth-child(3) {
            width: 10%; /* Adjusted width for Event Date */
        }

        td:nth-child(4) {
            width: 5%; /* Adjusted width for Credits Earned */
        }
        /* No td:nth-child(5) as Debits column is removed */

    </style>
</head>

<body lang="EN-US">
    <div id="certificate-download" class="certificate-download">
        <div class="certificate" id="certificate">
            <div class="section-1" id="section-1">
                <img width="347" height="183" id="logo" id="logo"
                    src="${process.env.REACT_APP_R2_URL}/socialcreds.png" />
                <p><span class="certificate-title">CERTIFICATE</span></p> <!-- Use class for consistency -->
            </div>
            <div class="certificate-body">
                <p class="congratulations-text">We would like to congratulate <b>${user.first_name} ${user.last_name}</b> for her
                outstanding work and
                dedication as a part of Social
                Cred and clocking in <b>${user.hours} hours!</b> </p>
                <div class="founder-section" id="founder-section">

                </div>
                <div class="volunteer-section" id="volunteer-section">

                </div>
            </div>
            <div class="badge-section" id="badge-section">
                
            </div>
            <div class="signatures" id="signatures">
                <div> <!-- Removed inline flex style -->
                    <img src="${process.env.REACT_APP_R2_URL}/sharmila_signature.png"
                        alt="sharmila_sign" />
                    <p> <b>Sharmila Martis Arora,</b><br>
                        Founder,<br>
                        Gift Of Time</p>
                </div>
               <div> <!-- Removed inline flex style -->
                    <img src="${process.env.REACT_APP_R2_URL}/padma_signature.png"
                        alt="padma_sign" /> <!-- Correct alt text -->
                    <p> <b>Padma Kuchibhotla,</b><br>
                        Co-Founder,<br>
                        Gift Of Time</p>
                </div>
            </div>
            <div class="ledger" id="ledger">
                <table>
                <thead>
                </thead>
                <tbody  id="ledger-table">
                </tbody>
                </table>
            </div>
        </div>
    </div>
</body>

</html>`